import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';

interface Organisation {
  name: string;
  subdomain: string;
}

const organisations: Organisation[] = [
  { name: "Konica Minolta", subdomain: "konica" },
  // Future clients added here
];

interface OrganisationSelectorProps {
  variant?: 'button' | 'standalone';
}

const getRedirectUrl = (subdomain: string): string => {
  // Always use internal /welcome route with subdomain as query param
  return `${window.location.origin}/welcome?org=${subdomain}`;
};

export function OrganisationSelector({ variant = 'button' }: OrganisationSelectorProps) {
  const [selectedOrg, setSelectedOrg] = useState<string>('');

  const handleRedirect = (subdomain?: string) => {
    const targetSubdomain = subdomain || selectedOrg;
    if (targetSubdomain) {
      window.location.href = getRedirectUrl(targetSubdomain);
    }
  };

  if (variant === 'button') {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="lg" className="touch-target">
            I'm an Employee
            <ChevronDown className="ml-2 h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center" className="w-56 bg-card border border-border z-50">
          {organisations.map((org) => (
            <DropdownMenuItem
              key={org.subdomain}
              onClick={() => handleRedirect(org.subdomain)}
              className="cursor-pointer"
            >
              {org.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  // Standalone variant
  return (
    <div className="space-y-4 mt-6">
      <Select value={selectedOrg} onValueChange={setSelectedOrg}>
        <SelectTrigger className="w-full bg-card border-border">
          <SelectValue placeholder="Select Your Organisation" />
        </SelectTrigger>
        <SelectContent className="bg-card border-border z-50">
          {organisations.map((org) => (
            <SelectItem key={org.subdomain} value={org.subdomain}>
              {org.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button 
        onClick={() => handleRedirect()} 
        disabled={!selectedOrg}
        className="w-full"
      >
        Go to Portal
      </Button>
    </div>
  );
}
